module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append( svg )
    ; __append("\n<div class=\"head\">\n    <span class=\"h-title\">Безопасный город</span>\n    <span class=\"h-description-1\">Аппаратно-программный комплекс Республики Татарстан</span>\n    <!--<span class=\"h-description-2\">на базе ЕГИС «ГЛОНАСС+112»</span>-->\n</div>\n<div class=\"center\">\n    <div class=\"login-card\">\n        <div class=\"l-head\">\n            <img src=\"")
    ; __append(escapeFn( logo ))
    ; __append("\">\n            <span class=\"l-title\">Сельское хозяйство</span>\n        </div>\n        <span class=\"l-rule\">Для авторизации заполните поля формы.</span>\n        <div class=\"l-input\">\n            <input type=\"text\" name=\"login\" id=\"login\" class=\"login-input\" required>\n            <label for=\"login\" id=\"login-label\" class=\"login-label\">Логин</label>\n        </div>\n        <div class=\"l-input\">\n            <input type=\"password\" name=\"password\" id=\"password\" class=\"login-input\" required>\n            <label for=\"password\" id=\"password-label\" class=\"login-label\">Пароль</label>\n            <button id=\"password-visible\" class=\"password-visibility visible_off\"></button>\n        </div>\n        <button id=\"submit\" class=\"login l-agronomy\">\n            Войти\n        </button>\n        <a href=\"#\" class=\"system-list\">Перейти к списку систем</a>\n    </div>\n</div>\n")
  }
  return __output.join("");

}